import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import { Reveal, SectionLabel } from "@/components/site/Reveal";
import { PURPOSES } from "@/lib/content";

const LAYOUT = [
  "lg:col-span-3 lg:row-span-2",
  "lg:col-span-3",
  "lg:col-span-3",
  "lg:col-span-3",
  "lg:col-span-3",
];

export default function Purposes() {
  return (
    <section className="mx-auto max-w-[1440px] px-5 py-24 sm:px-8 lg:px-12 lg:py-36" data-testid="browse-by-purpose">
      <div className="grid gap-8 lg:grid-cols-12 lg:items-end">
        <Reveal className="lg:col-span-7">
          <SectionLabel index="03">Browse by purpose</SectionLabel>
          <h2 className="mt-6 font-serif text-4xl leading-[1.05] text-charcoal sm:text-5xl lg:text-6xl">Find the right vehicle for the way you use it.</h2>
        </Reveal>
        <Reveal className="lg:col-span-4 lg:col-start-9" delay={0.1}>
          <p className="text-base leading-relaxed text-charcoal/80">Every vehicle in stock is tagged by how it suits everyday life — so you can start with what you need it to do, rather than a make or model.</p>
        </Reveal>
      </div>
      <div className="mt-16 grid gap-4 lg:grid-cols-6 lg:auto-rows-[300px]">
        {PURPOSES.map((p, i) => (
          <motion.div key={p.key} className={`${LAYOUT[i]} h-[340px] lg:h-auto`}
            initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.1 }}
            transition={{ duration: 0.9, delay: i * 0.07, ease: [0.2, 0.7, 0.2, 1] }}>
            <Link to={`/stock?category=${p.key}`} data-testid={`purpose-${p.key.toLowerCase()}`}
              className="img-zoom group on-dark relative block h-full overflow-hidden bg-forest text-paper">
              <img src={p.img} alt={`${p.title} vehicles`} loading="lazy" className="absolute inset-0 h-full w-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0F2620]/85 via-[#0F2620]/25 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 flex items-end justify-between gap-6 p-6 lg:p-8">
                <div>
                  <p className="font-serif text-sm italic text-stone">0{i + 1}</p>
                  <h3 className="font-serif text-4xl lg:text-5xl">{p.title}</h3>
                  <p className="mt-2 max-w-sm text-sm leading-relaxed text-paper/90">{p.text}</p>
                </div>
                <span className="grid h-12 w-12 shrink-0 place-items-center rounded-full border border-paper/50 transition-colors duration-500 group-hover:bg-paper group-hover:text-forest">
                  <ArrowRight className="h-5 w-5" strokeWidth={1.5} />
                </span>
              </div>
            </Link>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
